module.exports = __webpack_public_path__ + "static/logo-777a39e4c70d99028a2edf24cd53a763.png";